import { GET_DOWNLOAD_URL } from "../actions/types";

export default function (state = null, action: any) {
  switch (action.type) {
    case GET_DOWNLOAD_URL:
      return action.payload;
    default:
      return state;
  }
}
